import gql from 'graphql-tag'

export default gql`
  mutation documentHeaderImage($documentId: Int!) {
    documentHeaderImage(input: { document_id: $documentId })
  }
`
